var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.preferredThemeColor,
      class: ((_obj = {}), (_obj[_vm.hoveredPart] = true), _obj),
      attrs: { id: "chat-theme-editor" },
    },
    [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          { staticClass: "d-flex gap-5 featur-item" },
          [
            _c("FeatureItem", {
              attrs: {
                title: _vm.$t("message.theme"),
                icon: "ThemeIcon",
                type: "select",
                options: [{ id: "custom", label: "Custom Theme" }].concat(
                  _vm.allThemeColors
                    .map(function (x) {
                      return { id: x, label: x }
                    })
                    .filter(function (x) {
                      return x.id !== "custom"
                    })
                ),
                "default-select-option-placeholder": _vm.$t(
                  "message.selectATheme"
                ),
                description: _vm.$t("settings.themeDescription"),
                "show-null-select-option": false,
              },
              on: {
                click: function (e) {
                  return e.stopPropagation()
                },
              },
              model: {
                value: _vm.preferredThemeColor,
                callback: function ($$v) {
                  _vm.preferredThemeColor = $$v
                },
                expression: "preferredThemeColor",
              },
            }),
            _vm._v(" "),
            _c("FeatureItem", {
              attrs: {
                title: _vm.$t("theme.font"),
                icon: "FontIcon",
                type: "select",
                options: _vm.fonts.map(function (x) {
                  return { id: x, label: x }
                }),
                "default-select-option-placeholder": _vm.$t(
                  "message.selectATheme"
                ),
                description: _vm.$t("settings.fontDescription"),
              },
              model: {
                value: _vm.fontCustom,
                callback: function ($$v) {
                  _vm.fontCustom = $$v
                },
                expression: "fontCustom",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            key: _vm.preferredThemeColor,
            staticClass: "colors",
            staticStyle: { margin: "50px" },
          },
          _vm._l(_vm.getColors(), function (color) {
            return _c("ColorPickerItem", {
              key: color.id,
              attrs: {
                title: color.title,
                value: _vm.readColorValue(color.id),
                rawColor: _vm.readRawColorValue(color.id),
                "opacity-slider": color.configurableOpacity,
                "on-mouse-enter": function () {
                  return (_vm.hoveredPart = color.id)
                },
                "on-mouse-leave": function () {
                  return (_vm.hoveredPart = null)
                },
              },
              on: {
                input: function (value) {
                  return _vm.setColorValue(color.id, value)
                },
              },
            })
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "preview" }, [
        _c(
          "div",
          { staticClass: "demo-visitor-wrapper" },
          [_c("DemoVisitor")],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }